import React, { useState, useRef } from 'react'
import ModalNotificacion from './modalNotificacion.component';
import * as Constant from '../../../global/const';
import { useSelector } from 'react-redux';
import { ModalResumen } from '../../MisDatos/misPedidos.component'
//axios
import axios from 'axios'
import auth from '../../../Helpers/auth'
//texto enriquecido
import { Markup } from 'interweave';
//Loader
import Loader from "react-loader-spinner";

//print for pdf
import { useReactToPrint } from "react-to-print";
import Print from "../../ThankYou/Print";
import { useHistory } from 'react-router';

const CardNotificaciones = (props) => {
   const history = useHistory();
   const [showModal, setShowModal] = useState(false);
   const myRef = useRef();
   const myRef2 = useRef();
   const sucursal = useSelector(state => state.page.sucursal);
   const [notificaciones, setNotificaciones] = useState([])
   let user = JSON.parse(auth.getUsuario());
   const { setCarAlert, carAlert, notifications, showMessage } = props;
   const [loader, setLoader] = useState(false);
   const [img, setImg] = useState("");
   const [notificacionSelect, setNotificacionSelect] = useState("")
   const [expanded, setExpanded] = React.useState(false);
   const componentRef = useRef();
   const [pedido, setPedido] = useState("");
   const [productos, setProductos] = useState("");
   const [showModalResumen, setShowModalResumen] = useState({});



   const handlePrint = useReactToPrint({
      content: () => componentRef.current,
      documentTitle: 'Pedido - ORD-20201216005438791'
   });

   const handleChange = (panel) => {
      setExpanded(panel === expanded ? false : panel);
   };

   React.useEffect(() => {
      document.addEventListener('click', handleClickOutside, true);
      return () => {
         document.removeEventListener('click', handleClickOutside, true);
      };

   }, [carAlert])


   const handleClickOutside = (event) => {
      if (
         myRef.current &&
         !myRef.current.contains(event.target)
      ) {

         if (event.target.className.indexOf("activarCampana") >= 0) {

         } else {
            setCarAlert(false)
         }

         if (event.target.className.indexOf("modal1") >= 0) {
            console.log(event.target.className.indexOf("modal1"))
         } else {
            setProductos(null)

         }


      }

   };
   //petición para obtener la lista de notificaciones
   React.useEffect(() => {
      setLoader(true)
      getNotificaciones()
   }, [pedido, sucursal])


   const getPedido = async (nOrden) => {
      return await axios.get(Constant.GETRECIBO + '?numOrden=' + nOrden + '&numDoc=' + nOrden).then((response) => {
         return response.data
      }).catch((err) => {
         console.log("error ", err);
      })
   }



   const getNotificaciones = async () => {
      await axios.get(Constant.NOTIFICACIONES + `?correo=${user.email}&nit=${user.nit}&codigo=${sucursal.codigo}&agencia=${sucursal.agencia}`).then((response) => {
         setNotificaciones(response.data);
      }).catch((err) => {
         console.log("error ", err);
      }).finally(()=>{
         setLoader(false)
      })
   }

   // var Slider = {
   //    overflow: "hidden",
   //    position: "absolute",
   //    width: "20.2%",
   //    height: "70vh",
   //    top: "90%",
   //    left: "2%",
   //    background: "#FFFFFF",
   //    boxShadow: "0px 14px 14px rgba(0, 0, 0, 0.25)",
   //    borderRadius: "33px 33px 33px 33px",
   //    transition: 'all 0.8s',
   //    cursor: 'auto',
   //    opacity: '1'
   // }

   // var CloseSlider = {
   //    overflow: "hidden",
   //    position: "absolute",
   //    width: "20.2%",
   //    height: "0vh",
   //    top: "90%",
   //    left: "2%",
   //    background: "#FFFFFF",
   //    boxShadow: "0px 14px 14px rgba(0, 0, 0, 0.25)",
   //    borderRadius: "33px 0px 0px 33px",
   //    transition: 'all 0.8s',
   //    cursor: 'auto',
   //    opacity: '1'
   // }

   return (
      <div className={`bodyNotificacion ${carAlert ? "show" : "hide"}`} ref={myRef} >
         <div className="contenido">
            {
               loader ?
                  <div className="loader_centerPages" style={{ height: "50vh" }}>
                     <Loader
                        type="ThreeDots"
                        color="#0075BB"
                        height={100}
                        width={100}

                     />
                  </div> :
                  <>
                     <div className="notificaciones overflow-auto scrollSlider">
                        {
                           notificaciones.map((notificacion, i) => (
                              <div
                                 className="cuerpo"
                                 key={`${i}notificacion`}
                                 onClick={
                                    () => {
                                       setShowModal(true)
                                       setNotificacionSelect(notificacion)
                                       setImg(`${Constant.URL_BASE_IMAGES}Notificaciones/${notificacion.id}.jpg`)
                                    }}
                              >
                                 <h6> {notificacion.titulo}</h6>
                                 {/* <h6 style={{ fontSize: "13px" }}><Markup content={notificacion.descripcion} /></h6> */}
                              </div>
                           )
                           )
                        }
                        < hr />
                        {
                           notifications
                           &&
                           notifications.map(
                              (noti, i) => {
                                 let objetoComoponent = { message: noti.novedades, pedido }
                                 return (
                                    <div
                                       className='cuerpo'
                                       onClick={
                                          () => {
                                             getPedido(noti.orden, noti)
                                                .then(
                                                   (res) => {
                                                      setCarAlert(false);
                                                      history.push(
                                                         "./MiPerfil/MisPedidos",
                                                         {
                                                            ModalResumen: true,
                                                            noti,
                                                            pedido: res.pedido,
                                                            novedad: noti.novedades
                                                         }
                                                      );
                                                   }
                                                );
                                             setShowModalResumen({ objetoComoponent, orden: noti.orden }
                                             )
                                          }
                                       }
                                       key={`${i}novedad`}
                                    >
                                       <h6>
                                          {noti.novedades + noti.orden}
                                       </h6>
                                       <hr />
                                    </div>
                                 )
                              }
                           )
                        }

                     </div>
                  </>
            }

            {
               showModal ?
                  <>
                     {/* { setCarAlert(false)} */}
                     <div className="modalNotificacion">
                        < ModalNotificacion setShowModal={setShowModal} notificacionSelect={notificacionSelect} img={img} />
                     </div>
                  </>

                  : ""
            }
         </div>

      </div>

   )
}
export default CardNotificaciones;